import type { DeIdentificationRule } from '../../entities/ai-assist-config';

export interface ApplyDeidentificationResult {
  text: string;
  appliedRuleIds: string[];
}

export function applyDeidentificationRules(input: string, rules: DeIdentificationRule[]): ApplyDeidentificationResult {
  let text = input;
  const appliedRuleIds: string[] = [];

  for (const rule of rules.slice().sort((left, right) => right.originalValue.length - left.originalValue.length || left.ruleId.localeCompare(right.ruleId))) {
    if (!rule.enabled || rule.conflictStatus !== 'valid' || !rule.originalValue || !rule.replacementValue) {
      continue;
    }
    if (!text.includes(rule.originalValue)) {
      continue;
    }
    text = text.split(rule.originalValue).join(rule.replacementValue);
    appliedRuleIds.push(rule.ruleId);
  }

  return { text, appliedRuleIds };
}
